import { render, staticRenderFns } from "./SectionSMS.vue?vue&type=template&id=faf26ce8&scoped=true&"
import script from "./SectionSMS.vue?vue&type=script&lang=js&"
export * from "./SectionSMS.vue?vue&type=script&lang=js&"
import style0 from "./SectionSMS.vue?vue&type=style&index=0&id=faf26ce8&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf26ce8",
  null
  
)

export default component.exports